import { LanguageCodeKey, PrimaryLanguage, languageCode } from 'modules/types';

export const getPrimaryLanguage = (primaryLanguage?: PrimaryLanguage): LanguageCodeKey => {
  if (primaryLanguage === languageCode.es) return 'es';
  return 'en';
};

export default {};
